





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import Transaccion from "@/models/tarjeta/transaccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import moment from "moment";
@Component
export default class TransaccionDetalle extends BaseVue {
  @Prop() readonly value!: any | number;
  protected repository!: BaseRepository<Transaccion>;
  transaccion: Transaccion | null = new Transaccion();
  loading = false;
  constructor() {
    super();
    this.repository = new BaseRepository<Transaccion>("transaccion");
  }
  //    get isId() {
  //     return !isNaN(this.value);
  //   }

  @Watch("value", { deep: true, immediate: true })
  async OnValueChange(value: any) {
    if (!value) {
      this.transaccion = null;
      return;
    }
    if (isNaN(value)) {
      this.transaccion = this.value;
    } else {
      this.loading = true;
      this.transaccion = await this.repository.byId(
        value,
        "Subsidio|Tarjeta.Banco|Comercio"
      );
      this.loading = false;
    }
    this.$emit("change", value);
  }
}
